import { Box, TextField, TextFieldSize } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const LocationIconStyled = styled(Box)`
  position: absolute;
  ${({ theme }) =>
    css`
      top: ${theme.spacings[450]};
      right: ${theme.spacings[500]};
    `}
`;
export const TextFieldStyled = styled(TextField).attrs({ size: TextFieldSize.LARGE })`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[300]};
    font-family: ${theme.fontFamilies['graphik']};
  `}
`;
